import rightArrowIcon from "assets/icons/rightArr.svg";
import i18next from "i18next";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../assets/scss/Views/welcome.scss";
import PrimaryButton from "../Components/PrimaryButton";
import VideoJS from "../Components/VideoPlayer/VideoJS";
// import InteractiveContext from "context/InteractiveContext";

const Intro = ({ setPageTitle, setShowMenuToggler, setIsBackgroundMusic }) => {
  const { t } = useTranslation();
  const playerRef = useRef(null);
  const [isCompleted, setisCompleted] = useState(false);
  const [isPlayedOnce, setisPlayedOnce] = useState(false);
  const { resolvedLanguage } = i18next;
  useEffect(() => {
    setPageTitle("");
    setShowMenuToggler(false);
    setIsBackgroundMusic(false);
  }, [setPageTitle, setShowMenuToggler, setIsBackgroundMusic]);

  useEffect(() => {
    if (localStorage.getItem("zarastanie_intro_completed") === "true") {
      setisCompleted(true);
    }
  }, [setisPlayedOnce]);

  const videoJsOptions = useMemo(() => {
    return {
      controls: false,
      autoplay: true,
      loop: false,
      sources: "/videos/intro.mp4",
    };
  }, []);

  useEffect(() => {
    if (!playerRef.current) return;
    // remove old text tracks
    playerRef?.current
      ?.remoteTextTracks()
      .tracks_.forEach((track) =>
        playerRef.current.removeRemoteTextTrack(track)
      );

    if (resolvedLanguage !== "en") return;
    // add text track to current video
    playerRef?.current?.addRemoteTextTrack(
      {
        kind: "captions",
        src: "/subtitles/Intro_eng.vtt",
        mode: "showing",
        default: true,
        srcLang: "en",
        label: "en",
        language: "en",
      },
      true
    );
  }, [playerRef, resolvedLanguage]);

  const onVideoEndedHandler = (e) => {
    setisPlayedOnce(true);
    setisCompleted(true);
    localStorage.setItem("zarastanie_intro_completed", true);
    playerRef.current.currentTime(0);
    setTimeout(() => {
      playerRef.current.play();
    }, 300);
  };
  const onPlayerReadyHandler = (player) => {
    playerRef.current = player;
    playerRef.current.play();
    if (resolvedLanguage !== "en") return;
    // add text track to current video
    playerRef?.current?.addRemoteTextTrack(
      {
        kind: "captions",
        src: "/subtitles/Intro_eng.vtt",
        mode: "showing",
        default: true,
        srcLang: "en",
        label: "en",
        language: "en",
      },
      true
    );
  };

  return (
    <div>
      <div className="position-absolute bottom-0 w-100 d-flex justify-content-center pb-5 mb-2">
        {isPlayedOnce && (
          <Link className="nav-link" to="/scene">
            <PrimaryButton
              className="primary"
              text={t("See What`s Next")}
              hoveredText={t("See What`s Next")}
            />
          </Link>
        )}
        {isCompleted && !isPlayedOnce && (
          <Link
            className="nav-link position-absolute start-0 bottom-0 ms-5 mb-5 "
            to="/scene"
          >
            <button type="button" className={`button button--outline`}>
              <span> {t("Skip the intro")}</span>
              <Fragment>
                <span>&nbsp;&nbsp;</span>
                <img
                  src={rightArrowIcon}
                  alt="Right arrow"
                  height="10"
                  width="10"
                />
              </Fragment>
            </button>
          </Link>
        )}
      </div>
      <VideoJS
        options={videoJsOptions}
        onPlayerReady={onPlayerReadyHandler}
        onVideoEnded={onVideoEndedHandler}
      />
    </div>
  );
};

export default Intro;
